module.exports = __webpack_public_path__ + "img/kontakt_1280.3f9e270b.webp";